import {renderPopout} from './render_popout'

export const buildPopout = ({showPopout, formatTitle, formatSeriesLabel, formatSeriesValue, ExtraContent}) => {
	if (!showPopout) return {enabled: false}

	return {
		enabled: true,
		shared: true,
		intersect: false,
		custom: apexContext => renderPopout({apexContext, formatTitle, formatSeriesLabel, formatSeriesValue, ExtraContent}),
	}
}
